// extracted by mini-css-extract-plugin
export default {"artistInfoStar":"FRD6gD55rcSgWq1GTdVI"};